import React from "react";
export default function MenuItems(props) {
  return (
    <>
      <div className="product-container-menu">
        <div className={props.image}></div>
        <span className="product-description-menu">
          <b>{props.description}</b>
        </span>
      </div>
    </>
  );
}
